export class Sha512_224{

    static  getHash(text: string){
        //константы
        const K = [
            '428a2f98d728ae22', '7137449123ef65cd', 'b5c0fbcfec4d3b2f', 'e9b5dba58189dbbc',
            '3956c25bf348b538', '59f111f1b605d019', '923f82a4af194f9b', 'ab1c5ed5da6d8118',
            'd807aa98a3030242', '12835b0145706fbe', '243185be4ee4b28c', '550c7dc3d5ffb4e2',
            '72be5d74f27b896f', '80deb1fe3b1696b1', '9bdc06a725c71235', 'c19bf174cf692694',
            'e49b69c19ef14ad2', 'efbe4786384f25e3', '0fc19dc68b8cd5b5', '240ca1cc77ac9c65',
            '2de92c6f592b0275', '4a7484aa6ea6e483', '5cb0a9dcbd41fbd4', '76f988da831153b5',
            '983e5152ee66dfab', 'a831c66d2db43210', 'b00327c898fb213f', 'bf597fc7beef0ee4',
            'c6e00bf33da88fc2', 'd5a79147930aa725', '06ca6351e003826f', '142929670a0e6e70',
            '27b70a8546d22ffc', '2e1b21385c26c926', '4d2c6dfc5ac42aed', '53380d139d95b3df',
            '650a73548baf63de', '766a0abb3c77b2a8', '81c2c92e47edaee6', '92722c851482353b',
            'a2bfe8a14cf10364', 'a81a664bbc423001', 'c24b8b70d0f89791', 'c76c51a30654be30',
            'd192e819d6ef5218', 'd69906245565a910', 'f40e35855771202a', '106aa07032bbd1b8',
            '19a4c116b8d2d0c8', '1e376c085141ab53', '2748774cdf8eeb99', '34b0bcb5e19b48a8',
            '391c0cb3c5c95a63', '4ed8aa4ae3418acb', '5b9cca4f7763e373', '682e6ff3d6b2b8a3',
            '748f82ee5defb2fc', '78a5636f43172f60', '84c87814a1f0ab72', '8cc702081a6439ec',
            '90befffa23631e28', 'a4506cebde82bde9', 'bef9a3f7b2c67915', 'c67178f2e372532b',
            'ca273eceea26619c', 'd186b8c721c0c207', 'eada7dd6cde0eb1e', 'f57d4f7fee6ed178',
            '06f067aa72176fba', '0a637dc5a2c898a6', '113f9804bef90dae', '1b710b35131c471b',
            '28db77f523047d84', '32caab7b40c72493', '3c9ebe0a15c9bebc', '431d67c49c100d4c',
            '4cc5d4becb3e42b6', '597f299cfc657e2a', '5fcb6fab3ad6faec', '6c44198c4a475817',
        ].map(k => LongNumber.fromString(k));
        const H = [
            '0x8C3D37C819544DA2', '0x73E1996689DCD4D6', '0x1DFAB7AE32FF9C82',
            '0x679DD514582F9FCF', '0x0F6D2B697BD44DA8', '0x77E36F7304C48942',
            '0x3F9D85A86A1D36C8', '0x1112E6AD91D692A1'
        ].map(h => LongNumber.fromString(h));
       //переводит, заданный текст, в строку битов
        function toBinStr(text){
            var binStr="";
            for(let i=0; i<text.length;i++){
                let symbol = text.charCodeAt(i).toString(2),
                len = Math.ceil(symbol.length/8);
                symbol = "00000000"+symbol; 
                binStr+= symbol.slice(-8*len);
            }
            return binStr;
        }
        //дополнение сообщения
        function makeMessage(text){
        
            var message = toBinStr(text);
            var l = message.length.toString(2);
            message+="1"; //добавление 1
        
            //добавление нулевых бит для кратности 896
            var div = Math.floor(message.length/896)
          
            var k= 1024 - message.length%896;
            if(div==0){
                k= 896 - message.length;
            }
    
            while(k!=0){
                message+= "0";
                k--;
            }
        
            //перевод размера исходного текста в 128-битовое представление 
            var s="";
            for(var i=0;i<128-l.length;i++){
                s+="0";
            }
            message+=s+l;
           return message; 
        }
        //разбиение дополненного сообщения на блоки
        function splitMessege(message){
            
            var Mn = [];
            var N = Math.ceil(message.length/1024);
            for(var i=0;i<N;i++){
                Mn[i]=[];
                for(var j=0;j<16;j++){
                    var s = 64*j+1024*i;
                    var f = 64*(j+1)+1024*i;
                    var str = message.slice(s,f);
                    Mn[i][j] = LongNumber.fromBin(str);
                }
        
            }
            return Mn;
        }
        var Mn = splitMessege(makeMessage(text));
       
        for(var i=0; i<Mn.length; i++){
    
            //1
            var W = [];
            var t=0;
            while(t!=16){
                W[t] = Mn[i][t];
                t++;
            }
            while(t!=80){
                W[t] = (Sha512_224.σ1(W[t-2]).add(W[t-7]).add(Sha512_224.σ0(W[t-15])).add(W[t-16]));
                t++;
            }
    
            //2
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];
            var f = H[5];
            var g = H[6];
            var h = H[7];
           
            //3 
            for(t = 0; t < 80; t++){
                var temp1 = h.add(Sha512_224.Σ1(e)).add(Sha512_224.Ch(e, f, g)).add(K[t]).add(W[t]);
                var temp2 = Sha512_224.Σ0(a).add(Sha512_224.Maj(a, b, c));
                h = g;
                g = f;
                f = e;
                e = d.add(temp1);
                d = c;
                c = b;
                b = a;
                a = temp1.add(temp2);
            }
            
    
            //4
            H[0] = H[0].add(a);
            H[1] = H[1].add(b);
            H[2] = H[2].add(c);
            H[3] = H[3].add(d);
            H[4] = H[4].add(e);
            H[5] = H[5].add(f);
            H[6] = H[6].add(g);
            H[7] = H[7].add(h);
        }
     
        let hash="";
        for (let h=0; h<3; h++) hash+= H[h].toString();
        hash+= H[3].toString().slice(0,8);
        
        return hash;
    }
    private static  ROTR(x, n) { // emulates (x >>> n) | (x << (64-n)
        if (n == 0) return x;
        if (n == 32) return new LongNumber(x.lo, x.hi);
    
        let hi = x.hi, lo = x.lo;
    
        if (n > 32) {
            [ lo, hi ] = [ hi, lo ]; // swap hi/lo
            n -= 32;
        }
    
        const hi1 = (hi >>> n) | (lo << (32-n));
        const lo1 = (lo >>> n) | (hi << (32-n));
    
        return new LongNumber(hi1, lo1);
    }
       private static Σ0(x) { return Sha512_224.ROTR(x, 28).xor(Sha512_224.ROTR(x, 34)).xor(Sha512_224.ROTR(x, 39)); }
       private static Σ1(x) { return Sha512_224.ROTR(x, 14).xor(Sha512_224.ROTR(x, 18)).xor(Sha512_224.ROTR(x, 41)); }
       private static σ0(x) { return Sha512_224.ROTR(x,  1).xor(Sha512_224.ROTR(x,  8)).xor(x.shr(7)); }
       private static σ1(x) { return Sha512_224.ROTR(x, 19).xor(Sha512_224.ROTR(x, 61)).xor(x.shr(6)); }
       private static Ch(x, y, z)  { return (x.and(y)).xor(x.not().and(z)); }         // 'choice'
       private static Maj(x, y, z) { return (x.and(y)).xor(x.and(z)).xor(y.and(z)); } // 'majority'
    }
    class LongNumber{
         hi: number;
         lo: number;
        constructor(hi, lo) {
            this.hi = hi >>> 0;
            this.lo = lo >>> 0;
        }
        static fromString(str) {
            const hi = parseInt(str.slice(0, -8), 16);
            const lo = parseInt(str.slice(-8), 16);
    
            return new LongNumber(hi, lo);
        }
        static fromBin(str){
            const hi = parseInt(str.slice(0, 32), 2);
            const lo = parseInt(str.slice(-32), 2);
            return new LongNumber(hi, lo);
        }
        toString() {
            const hi = ('00000000'+this.hi.toString(16)).slice(-8);
            const lo = ('00000000'+this.lo.toString(16)).slice(-8);
    
            return hi + lo;
        }
        add(that) { // addition modulo 2^64
            const lo = this.lo + that.lo;
            const hi = this.hi + that.hi + (lo>0x100000000 ? 1 : 0); // carry top bit if lo > 2^32
    
            return new LongNumber(hi >>> 0, lo >>> 0);
        }
        and(that) { // &
            return new LongNumber(this.hi & that.hi, this.lo & that.lo);
        }
        xor(that) { // ^
            return new LongNumber(this.hi ^ that.hi, this.lo ^ that.lo);
        }
        not() {  // ~
            return new LongNumber(~this.hi, ~this.lo);
        }
        shr(n) { // >>>
            if (n ==  0) return this;
            if (n == 32) return new LongNumber(0, this.hi);
            if (n >  32) return new LongNumber(0, this.hi >>> n-32);
            /* n < 32 */ return new LongNumber(this.hi >>> n, this.lo >>> n | this.hi << (32-n));
        }
    }


